import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckInShell, Icon } from "../../components/CheckInDesign";
import { getPreferredIdUploadLanguage } from "../../components/languagePreference";
import { ERROR_KIND, getLocalizedErrorCopy } from "../../components/userFacingErrors";

export default function ServiceUnavailable() {
  const lang = getPreferredIdUploadLanguage();
  const it = lang === "it";
  const location = useLocation();
  const navigate = useNavigate();
  const retryPath = location.state?.retryPath;
  const reason = location.state?.reason || ERROR_KIND.TEMPORARY;
  const copy = getLocalizedErrorCopy(reason, lang);

  const retry = () => {
    if (retryPath) {
      navigate(retryPath, { replace: true });
      return;
    }
    navigate(-1);
  };

  return (
    <CheckInShell>
      <div className="v0-card-scroll">
        <div className="v0-not-found-panel">
          <div className="v0-not-found-badge" aria-hidden>
            <Icon name="alert" size={28} />
          </div>
          <div className="v0-hero-copy v0-not-found-copy">
            <h1>{copy.title}</h1>
            <p>{copy.body}</p>
          </div>
          <button
            type="button"
            className="btn v0-primary-button v0-not-found-retry"
            onClick={retry}
          >
            {it ? "Riprova" : "Try again"}
          </button>
        </div>
      </div>
    </CheckInShell>
  );
}
